module.exports = __webpack_public_path__ + "static/media/D7.de4ddc03.png";